export interface IState {
	articles: IArticle[]
	filters: IFilter[]
	query: string
	showFilter: boolean,
	hitsPerPage: number,
	currentPage: number,
}

export interface IFilter {
	name: string
	selected: boolean
}

export interface IArticle {
	title: string
	uri: string
	preamble: string
	image: string
	labels: string[]
}

const defaultState: IState = {
	articles: [],
	showFilter: false,
	filters: [],
	query: '',
	hitsPerPage: 10,
	currentPage: 0,
}

export default defaultState;
